import { Columns } from '@shared/interfaces/table/column-config';
import { MeterDto } from '@app/api/nts';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';

export const conversionFactorMasterdata: Columns<MeterDto>[] = [
  {
    title: 'A14',
    key: 'conversionFactorA14',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'A23',
    key: 'conversionFactorA23',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'R12',
    key: 'conversionFactorR12',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'R34',
    key: 'conversionFactorR34',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
]
